import { render, staticRenderFns } from "./CreateUserModal.vue?vue&type=template&id=2059fd6b&scoped=true&"
import script from "./CreateUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserModal.vue?vue&type=style&index=0&id=2059fd6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059fd6b",
  null
  
)

export default component.exports